module.exports = __webpack_public_path__ + "media/images/emblems/Muralto-coat_of_arms-121d4198a39926078492737556a9843b.svg";